import { gql } from '@apollo/client';
import { Box, Collapse, Typography } from '@mui/material';
import { CheckboxMenuItem } from 'components/common/form/Select';
import { IconLinearArrowDown } from 'components/icons/components/linear/IconLinearArrowDown';
import { getCreatorHandleWithPrefix } from 'features/creator';
import {
  CreatorFragmentSlaAnalyticsFilterByPlatformCollapsibleItemFragment,
  Platform,
} from 'graphql/generated';
import { theme } from 'styles/theme';

// eslint-disable-next-line
gql`
  fragment CreatorFragmentSLAAnalyticsFilterByPlatformCollapsibleItem on CreatorModel {
    id
    handle
    platform
  }
`;

export type SLAAnalyticsFilterByPlatformCollapsibleItemProps = {
  platform: Platform;
  icon: ({
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & {
    size?: number;
  }) => React.ReactSVGElement;
  label: string;
  isCollapseOpen: boolean;
  isPlatformSelected: boolean;
  selectedCreatorIds: string[];
  onToggleCollapse?: () => void;
  onTogglePlatformCheckbox?: () => void;
  hideCreatorHandles?: boolean;
  creatorHandles: CreatorFragmentSlaAnalyticsFilterByPlatformCollapsibleItemFragment[];
  onToggleCreatorCheckbox?: (creatorId: string) => void;
  renderExtendItems?: () => React.ReactNode;
};

export const SLAAnalyticsFilterByPlatformCollapsibleItem = ({
  platform,
  icon,
  label,
  isCollapseOpen,
  isPlatformSelected,
  onToggleCollapse,
  onTogglePlatformCheckbox,
  hideCreatorHandles,
  creatorHandles,
  selectedCreatorIds,
  onToggleCreatorCheckbox,
  renderExtendItems,
}: SLAAnalyticsFilterByPlatformCollapsibleItemProps) => {
  const Icon = icon;

  return (
    <Box>
      <CheckboxMenuItem
        checkboxPosition="end"
        label={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: '100%',
            }}
            onClick={onToggleCollapse}
          >
            <IconLinearArrowDown
              size={16}
              color={theme.colors?.utility[700]}
              // open/close collapse view should rotate the icon
              style={{
                transform: isCollapseOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
            <Icon size={16} color={theme.colors?.utility[700]} />
            <Typography variant="headline-xs">{label}</Typography>
          </Box>
        }
        value={platform}
        checked={isPlatformSelected}
        onClick={onTogglePlatformCheckbox}
      />
      <Collapse in={isCollapseOpen}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            pl: 6,
          }}
        >
          {!hideCreatorHandles &&
            creatorHandles.map((creator) => {
              const isChecked = selectedCreatorIds.includes(creator.id);
              return (
                <CheckboxMenuItem
                  checkboxPosition="end"
                  label={getCreatorHandleWithPrefix(creator.handle)}
                  value={creator.id}
                  checked={isChecked}
                  onClick={() => {
                    onToggleCreatorCheckbox?.(creator.id);
                  }}
                  isCheckboxExclusiveClick={false}
                />
              );
            })}
          {renderExtendItems?.()}
        </Box>
      </Collapse>
    </Box>
  );
};
